import Vue from 'vue'
import Vuex from 'vuex'
import config from './config'
import { Message } from 'element-ui'
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        isVerified: false, //是否已验证过验证码
        verifyCallback: [],//验证后回调
        pending: false,//是否正在请求ajax连接，出现遮罩层
        message: '', //全局提示消息
        showVerify: false, //展示验证码界面
        token: null,
    },
    mutations: {
        message(state, v) {
            let m = Message({
                message: v,
                offset:300,
                type: 'error',
                duration:config.message_time,
                center: true
            })
            m.$el.addEventListener('click',()=>{
                m.close()
            });
            // state.message = v;
            // if (config.message_time) {
            //     setTimeout(() => {
            //         state.message = '';
            //     }, config.message_time)
            // }
        },
        changeVerify(state, v) {
            state.showVerify = v;
        },
        addVerifyCallback(state, v) {
            if (!state.isVerified && v && v instanceof Function)
                state.verifyCallback.push(v);
        },
        doVerifyCallback(state) {
            state.verifyCallback.forEach(fun => fun());
            state.verifyCallback = [];
        },
        changePending(state, v) {
            if (v !== null) {
                state.pending = v;
            } else {
                state.pending = !state.pending;
            }
        },
        loadSession(state) {
            let user = window.localStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
                state.user = user.user;
                state.token = user.token;
            }
        },
        setUser(state, data) {
            state.user = data.user;
            state.token = data.token;
            window.localStorage.setItem('user', JSON.stringify(data));
        },
        setVerified(state, data) {
            state.isVerified = data
        },
        logout(state) {
            state.user = null;
            state.token = null;
            window.localStorage.removeItem('user');
        }
    },
    actions: {}
})
